import { usePermissions } from './PermissionsContext';

/**
 * Renderiza sus hijos solo si el usuario tiene el permiso indicado.
 * La autorización real la hace siempre el servidor; esto solo oculta la UI.
 */
export default function PermissionGate({ permission, children }) {
  const { hasPermission } = usePermissions();
  return hasPermission(permission) ? children : null;
}
